import defaultTheme from './default';
// import successTheme from './success'
// import secondaryTheme from './secondary'
// import darkTheme from './dark'

import { createTheme } from '@material-ui/core';
import { FONT_FAMILY } from './fontFamily';

const overrides = {
  spacing: 4,
  palette: {
    type: 'light',
    primary: {
      main: '#010134',
    },
    secondary: {
      main: '#f50057',
    },
    info: {
      main: '#00d7ff',
    },
    warning: {
      main: '#ff9e00',
    },
    success: {
      main: '#00d456',
    },
  },
  typography: {
    fontFamily: FONT_FAMILY,
  },
};

export default {
    default: createTheme({
      ...defaultTheme,
      ...overrides,
      typography: {
        fontFamily: FONT_FAMILY,
      },
      overrides: {

        MuiInputLabel: {
          shrink: {
            backgroundColor: '#FFFFFF',
            padding: '2px',
            borderRadius: '2px',
          },
        },

        MUIDataTableFilter: {
          root: {
            padding: '16px',
          },

          checkboxFormControl: {
            marginRight: '12px',
          },

          checkboxFormControlLabel: {
            marginLeft: '0px',
          },

        },
      },
    }),
    // secondary: createMuiTheme({ ...secondaryTheme, ...overrides }),
    // success: createMuiTheme({ ...successTheme, ...overrides }),
    // dark: createMuiTheme({ ...darkTheme, ...overrides, ...darkModeOverrides }),
};
